export const text = '#9CABB9';
export const hover = '#1961AC';
export const darkBlue = '#142637';
export const black = '#142637';
export const white = '#FFFFFF';

export const ease = 'cubic-bezier(0.4, 0, 0, 1)';


//----------------------------------------------Font Family ------------------------------------------//
export const title = `"Inter", Euclid Square, Arial, Helvetica, freesans, sans-serif `;
export const regular = `"Inter Regular"`;
export const bold = `"Inter Bold"`;
export const medium = `"Inter Medium"`;
export const semibold = `"Inter Semibold"`;
export const heavy = `"Avenir Heavy"`;
export const book = `"Avenir Heavy"`;
